import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment  from 'moment';
import { TransportService } from 'src/app/services/Transport/transport.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-print-student-vehicle-wise',
  templateUrl: './print-student-vehicle-wise.component.html',
  styleUrls: ['./print-student-vehicle-wise.component.css']
})
export class PrintStudentVehicleWiseComponent implements OnInit {
  SearchFilter = {
    VehicleID:0,
}
  constructor(private activatedRoute:ActivatedRoute,private transportService:TransportService,private spinnerService: Ng4LoadingSpinnerService,private lookupService:LookupService,public globalHelper :GlobalHelper) {
    this.activatedRoute.queryParams.subscribe(params => {
     
      this.SearchFilter.VehicleID =  params['VehicleID'];
      
      this.GetAllVehicleDetailsByStudent()
  });

   }

 



loading = false;
VehicleDetailsList:any;
VehicleStudentList:any;
VehicleList:any;
BranchDetails:any;
GetAllVehicleDetailsByStudent  () {
  
    
    this.spinnerService.show();     
        
       this.transportService.GetAllVehicleDetailsByStudent(JSON.stringify(this.SearchFilter)).subscribe( (response)=> {
            this.VehicleDetailsList = response.VehicleDetailsList;
           
            if (this.VehicleDetailsList != null) {
              this.VehicleList = response.VehicleDetailsList[0];
          }
          this.BranchDetails = response.BranchDetails;
          setTimeout( () =>{
              window.print();
          }, 300);
            this.spinnerService.hide();
            this.globalHelper. CheckActionStatus(response);
        });
    
}





  ngOnInit() {
    
  }

}
